import { Component, OnInit } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  FormControl,
  Validators,
} from "@angular/forms";
import { BloccoModel } from "../../../models/dashboard/blocco.model";

import { Configurations } from "../../../core/configurations";

@Component({
  selector: "app-item-type-manager",
  templateUrl: "./item-type-manager.component.html",
  styleUrls: ["./item-type-manager.component.css"],
})
export class ItemTypeManagerComponent implements OnInit {
  tipo: string;
  configuration: BloccoModel = new BloccoModel();

  form: FormGroup;
  loading: boolean;

  constructor(
    private fb: FormBuilder,
    private configurations: Configurations
  ) {}

  ngOnInit() {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({});
    switch (this.tipo) {
      case "IFRAME":
        this.addUrlFormControls();
        break;
      case "LINK":
        // this.addLinkFormControls();
        this.addAnchorFormControls();
        break;
      case "IMG":
        this.addImageFormControls();
        break;
      case "HTML":
        this.addTextFormControls();
        break;
      case "HTML_IMG":
        this.addImageTextFormControls();
        break;
      case "HTTP_Data":
        this.addHttpDataFormControls();
        break;
      case "DownloadExternalSource":
        this.addDownloadExternalFormControls();
        break;
      // case "incassi_in_lavorazione":
      //   break;
      // case "incassi_da_rendicontare":
      //   break;
      // case "brogliacci_incassi":
      //   break;
      default:
        // console.log("caso non trovato!");
        // console.log(this.tipo);
        break;
    }
  }

  addTextFormControls() {
    this.addDescrizioneControl();
  }
  addUrlFormControls() {
    this.addUrlControl();
  }
  addImageFormControls() {
    // this.addImageControl();
  }
  addLinkFormControls() {
    this.addTextControl();
    this.addUrlControl();
    // this.addImageControl();
  }
  addAnchorFormControls() {
    this.addAnchorControl();
    this.addDescrizioneControl();
  }
  addImageTextFormControls() {
    this.addTextControl();
    // this.addImageControl();
  }
  addHttpDataFormControls() {
    this.addRequestControl();
  }
  addDownloadExternalFormControls() {
    this.addDriverTypeControl();
    this.addDriverControl();
    this.addRequestControl();
  }

  addTextControl() {
    this.form.addControl(
      "descrizione",
      new FormControl(
        this.configuration.descrizione ? this.configuration.descrizione : "",
        Validators.compose([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(5000),
        ])
      )
    );
  }
  addUrlControl() {
    this.form.addControl(
      "iFrameSrc",
      new FormControl(
        this.configuration.iFrameSrc ? this.configuration.iFrameSrc : "",
        Validators.compose([Validators.required])
      )
    );
  }
  addAnchorControl() {
    this.form.addControl(
      "linkSrc",
      new FormControl(
        this.configuration.linkSrc ? this.configuration.linkSrc : "",
        Validators.compose([Validators.required])
      )
    );
  }
  addDescrizioneControl() {
    this.form.addControl(
      "descrizione",
      new FormControl(
        this.configuration.descrizione ? this.configuration.descrizione : "",
        Validators.compose([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(5000),
        ])
      )
    );
  }
  addImageControl() {
    this.form.addControl("image", new FormControl("", Validators.required));
  }
  addNameControl() {
    this.form.addControl(
      "name",
      new FormControl(
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(2),
          Validators.maxLength(100),
        ])
      )
    );
  }

  addDriverTypeControl() {
    this.form.addControl(
      "idBloccoDownloadExternalSourceDriverTipo",
      new FormControl(
        this.configuration.idBloccoDownloadExternalSourceDriver
          ? this.configuration.idBloccoDownloadExternalSourceDriver
          : this.configurations.getWebApiDriverTipo,
        Validators.compose([Validators.required])
      )
    );
  }

  addDriverControl() {
    this.form.addControl(
      "idBloccoDownloadExternalSourceDriver",
      new FormControl(
        this.configuration.idBloccoDownloadExternalSourceDriver
          ? this.configuration.idBloccoDownloadExternalSourceDriver
          : "",
        Validators.compose([Validators.required])
      )
    );
  }

  addRequestControl() {
    this.form.addControl(
      "idBloccoRouteAnagrafica",
      new FormControl(
        this.configuration.idBloccoRouteAnagrafica
          ? this.configuration.idBloccoRouteAnagrafica
          : "",
        Validators.compose([Validators.required])
      )
    );
  }

  resetFormGroup(tipo: string, conf: BloccoModel) {
    this.loading = true;
    this.tipo = tipo;
    if (conf) {
      this.configuration = conf;
    }
    this.createForm();

    this.loading = false;
  }
}



// WEBPACK FOOTER //
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/item-type-manager/item-type-manager.component.ts